import { FC, ReactNode } from "react";
import { Select, InputProps } from "@chakra-ui/react";
import { useField } from "formik";
import { InputWrapper } from "~/components";
import { OptGroupList } from "~/utils/formInputs/types";

interface Props extends InputProps {
  description?: string;
  id?: string;
  includeDefaultOption?: boolean;
  inputLeftElement?: ReactNode;
  label?: string;
  labelVariant?: string;
  minH?: string;
  name?: string;
  groupedOptions: OptGroupList;
  placeholder?: string;
  placeholderOptionLabel?: string;
}

export const GroupedSelectInput: FC<Props> = ({
  description,
  inputLeftElement,
  label,
  labelVariant,
  groupedOptions,
  placeholder = "Select your provider",
  ...props
}) => {
  const [field, meta] = useField(props as any);
  const type = "select";
  const inputId = `${type}-input-${props.id || props.name}`;
  return (
    <InputWrapper
      id={inputId}
      label={label}
      labelVariant={labelVariant}
      meta={meta}
      type={type}
      {...props}
    >
      <Select placeholder={placeholder} {...field}>
        {groupedOptions.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </Select>
    </InputWrapper>
  );
};
